function CustomerCard({ id, prename, name, address, town, customerNumber, postCode, onClick, status }) {
    return (
        <div
            key={id}
            className="customerCardContainer"
        >
            <div onClick={onClick}>
                <h2 className="customerCardHeading">{prename} {name}</h2>
                <p className="customerCardText"><strong>Adresse:</strong><br /> {address}</p>
                <p className="customerCardText"><strong>Stadt:</strong><br /> {town}</p>
                <p className="customerCardText"><strong>PLZ:</strong> {postCode}</p>
                <p className="customerCardText"><strong>Kundennummer:</strong> {customerNumber}</p>
                <p className="customerCardText"><strong>Status:</strong> {status}</p>
            </div>
        </div>
    );
}

export default CustomerCard;